/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleListResponse {
    getFixupPrototypeFunction() { return ScheduleListResponse.fixupPrototype; }

    static newInstance(model: Partial<ScheduleListResponse>): ScheduleListResponse {
        let obj = Object.assign(new ScheduleListResponse(), model);
        ScheduleListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleListResponse>): ScheduleListResponse {
        if (!model) return null;
        return ScheduleListResponse.newInstance(<ScheduleListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleListResponse) {
        if (!obj) return;

        models.ScheduleListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleListResponse): boolean {
        Object.setPrototypeOf(obj, ScheduleListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
